import React, { useEffect, useState } from "react";
import axios from "axios";
import "./eventsGallery.css";

const API_URL = process.env.REACT_APP_API_URL;

const EventsGallery = () => {
  const [events, setEvents] = useState([]);
  const [carouselIndices, setCarouselIndices] = useState({});
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [fullscreenEvent, setFullscreenEvent] = useState(null);

  useEffect(() => {
    const fetchActiveEvents = async () => {
      try {
        const response = await axios.get(`${API_URL}/events/events`);
        const data = response.data;

        if (!Array.isArray(data)) {
          console.error("Events data is not an array:", data);
          return;
        }

        const activeEvents = data.filter((e) => e.status === "active");
        setEvents(activeEvents);

        const defaultIndices = {};
        activeEvents.forEach((e) => {
          defaultIndices[e.id] = 0;
        });
        setCarouselIndices(defaultIndices);
      } catch (err) {
        console.error("Error fetching active events:", err);
      }
    };

    fetchActiveEvents();
  }, []);

  const nextImage = (eventId, total) => {
    setCarouselIndices((prev) => ({
      ...prev,
      [eventId]: (prev[eventId] + 1) % total,
    }));
  };

  const prevImage = (eventId, total) => {
    setCarouselIndices((prev) => ({
      ...prev,
      [eventId]: (prev[eventId] - 1 + total) % total,
    }));
  };

  const openFullscreen = (image, event) => {
    setFullscreenImage(image);
    setFullscreenEvent(event);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
    setFullscreenEvent(null);
  };

  return (
    <div className="events-gallery-container">
      <h2 className="gallery-heading">Our Events</h2>
      <div className="cards-container">
        {events.length === 0 ? (
          <p className="no-events-message">No active events found.</p>
        ) : (
          events.map((event) => {
            const currentImageIndex = carouselIndices[event.id] || 0;
            const images = event.images || [];
            const currentImage = images[currentImageIndex];

            return (
              <div className="event-card" key={event.id}>
                <div className="event-images-carousel">
                  {images.length > 0 ? (
                    <>
                      <button
                        className="carousel-nav-button carousel-nav-left"
                        onClick={() => prevImage(event.id, images.length)}
                      >
                        &#8249;
                      </button>
                      <img
                        src={currentImage}
                        alt={`Event ${event.name}`}
                        className="carousel-image"
                        onClick={() => openFullscreen(currentImage, event)}
                      />
                      <button
                        className="carousel-nav-button carousel-nav-right"
                        onClick={() => nextImage(event.id, images.length)}
                      >
                        &#8250;
                      </button>
                    </>
                  ) : (
                    <div className="no-image">No images available</div>
                  )}
                </div>
                <div className="event-info">
                  <h3>{event.name}</h3>
                  <p>{event.description}</p>
                  <div className="event-date">
                    {new Date(event.date).toLocaleDateString()}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {fullscreenImage && (
        <div className="fullscreen-overlay" onClick={closeFullscreen}>
          <div className="fullscreen-content" onClick={(e) => e.stopPropagation()}>
            <img src={fullscreenImage} alt="Fullscreen" className="fullscreen-img" />
            <div className="fullscreen-description">
              <h2>{fullscreenEvent.name}</h2>
              <p>{fullscreenEvent.description}</p>
              <p className="gallery-date">
                {new Date(fullscreenEvent.date).toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventsGallery;
